import { ReactNode, createContext, useContext } from 'react';
import { AccountTransactionTypesRequest, AccountTransactionType } from 'vopay';
import useFetchPartnerTransactionTypes from '../hooks/useApi/useFetchPartnerTransactionTypes';

type AccountTransactionTypes = {
  transactionTypes: AccountTransactionType[];
  fetchPartnerTransactionTypes: (requestParams: AccountTransactionTypesRequest) => void;
};

export const AccountTransactionTypesContext = createContext<AccountTransactionTypes>({
  transactionTypes: [],
  fetchPartnerTransactionTypes: () => {},
});

export const AccountTransactionTypesProvider = ({ children }: { children: ReactNode }): React.JSX.Element => {
  const { fetchPartnerTransactionTypes, transactionTypes } = useFetchPartnerTransactionTypes();

  return (
    <AccountTransactionTypesContext.Provider
      value={{
        transactionTypes,
        fetchPartnerTransactionTypes,
      }}
    >
      {children}
    </AccountTransactionTypesContext.Provider>
  );
};

export const useAccountTransactionTypes = (): AccountTransactionTypes => useContext(AccountTransactionTypesContext);
